import resizeCharts from './resizeCharts';
import resizeWidgets from './resizeWidgets';

const triggerResize = function() {
    resizeWidgets();
    resizeCharts();
};

export default triggerResize;
